var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    y: 0.255859,
    width: 41.4887,
    height: 41.4887,
    rx: 18.3003,
    fill: "#797A7A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.668 20.9984C11.668 15.977 15.7387 11.9062 20.7602 11.9062C25.7816 11.9062 29.8523 15.977 29.8523 20.9984C29.8523 26.0199 25.7816 30.0906 20.7602 30.0906C19.1642 30.0906 17.6625 29.6789 16.3574 28.9553C16.2776 28.911 16.1999 28.9091 16.1445 28.9287L14.0109 29.6826C12.7037 30.1445 11.4445 28.8853 11.9064 27.5781L12.6915 25.3562C12.7103 25.3029 12.7095 25.2285 12.6694 25.1505C12.0291 23.9052 11.668 22.4931 11.668 20.9984ZM16.5738 22.0979C17.1577 22.0979 17.6311 21.6245 17.6311 21.0406C17.6311 20.4567 17.1577 19.9834 16.5738 19.9834C15.9899 19.9834 15.5166 20.4567 15.5166 21.0406C15.5166 21.6245 15.9899 22.0979 16.5738 22.0979ZM21.8596 21.0406C21.8596 21.6245 21.3862 22.0979 20.8023 22.0979C20.2185 22.0979 19.7451 21.6245 19.7451 21.0406C19.7451 20.4567 20.2185 19.9834 20.8023 19.9834C21.3862 19.9834 21.8596 20.4567 21.8596 21.0406ZM25.0318 22.0979C25.6157 22.0979 26.0891 21.6245 26.0891 21.0406C26.0891 20.4567 25.6157 19.9834 25.0318 19.9834C24.4479 19.9834 23.9746 20.4567 23.9746 21.0406C23.9746 21.6245 24.4479 22.0979 25.0318 22.0979Z",
    fill: "#797A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.476c30c9176db8aded7c9358e130dcc9.svg";
export { ForwardRef as ReactComponent };